import { CultureInfo } from '../culture-info.model';
import { CultureInfoEs } from './es';

/**
 * @ignore
 */
export const CultureInfoEsAW: CultureInfo = {
  name: 'es-AW',
  displayName: 'español (Aruba)',
  iso3LanguageCode: 'spa',
  iso2LanguageCode: 'es',
  ietfLanguageTag: 'es-AW',
  parent: CultureInfoEs
};
